var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.5H3.75C1.67893 0.5 0 2.17893 0 4.25V12.75C0 14.8211 1.67893 16.5 3.75 16.5H12.25C14.3211 16.5 16 14.8211 16 12.75V4.25C16 2.17893 14.3211 0.5 12.25 0.5Z",
    fill: "url(#paint0_radial_372_1075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.5H3.75C1.67893 0.5 0 2.17893 0 4.25V12.75C0 14.8211 1.67893 16.5 3.75 16.5H12.25C14.3211 16.5 16 14.8211 16 12.75V4.25C16 2.17893 14.3211 0.5 12.25 0.5Z",
    fill: "url(#paint1_radial_372_1075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00056 2.25C6.30319 2.25 6.09013 2.25744 5.4235 2.28775C4.75813 2.31825 4.30394 2.42356 3.90656 2.57812C3.49544 2.73775 3.14675 2.95131 2.79938 3.29881C2.45169 3.64625 2.23813 3.99494 2.078 4.40587C1.923 4.80338 1.81756 5.25775 1.78762 5.92281C1.75781 6.5895 1.75 6.80263 1.75 8.50006C1.75 10.1975 1.7575 10.4099 1.78775 11.0765C1.81838 11.7419 1.92369 12.1961 2.07812 12.5934C2.23787 13.0046 2.45144 13.3533 2.79894 13.7006C3.14625 14.0483 3.49494 14.2624 3.90575 14.422C4.30344 14.5766 4.75769 14.6819 5.42294 14.7124C6.08962 14.7427 6.3025 14.7501 7.99981 14.7501C9.69738 14.7501 9.90975 14.7427 10.5764 14.7124C11.2417 14.6819 11.6964 14.5766 12.0941 14.422C12.5051 14.2624 12.8532 14.0483 13.2005 13.7006C13.5482 13.3533 13.7617 13.0046 13.9219 12.5936C14.0755 12.1961 14.181 11.7417 14.2122 11.0766C14.2422 10.41 14.25 10.1975 14.25 8.50006C14.25 6.80263 14.2422 6.58962 14.2122 5.92294C14.181 5.25756 14.0755 4.80344 13.9219 4.40606C13.7617 3.99494 13.5482 3.64625 13.2005 3.29881C12.8529 2.95119 12.5052 2.73762 12.0938 2.57819C11.6953 2.42356 11.2409 2.31819 10.5755 2.28775C9.90881 2.25744 9.69656 2.25 7.99862 2.25H8.00056ZM7.43988 3.37631C7.60631 3.37606 7.792 3.37631 8.00056 3.37631C9.66938 3.37631 9.86712 3.38231 10.5261 3.41225C11.1355 3.44012 11.4663 3.54194 11.6866 3.6275C11.9783 3.74075 12.1862 3.87619 12.4048 4.095C12.6236 4.31375 12.7589 4.52206 12.8725 4.81375C12.9581 5.03375 13.06 5.3645 13.0878 5.97388C13.1177 6.63275 13.1242 6.83062 13.1242 8.49862C13.1242 10.1666 13.1177 10.3646 13.0878 11.0234C13.0599 11.6327 12.9581 11.9635 12.8725 12.1836C12.7593 12.4753 12.6236 12.6829 12.4048 12.9016C12.1861 13.1203 11.9784 13.2557 11.6866 13.369C11.4665 13.4549 11.1355 13.5565 10.5261 13.5844C9.86725 13.6143 9.66938 13.6208 8.00056 13.6208C6.33169 13.6208 6.13387 13.6143 5.47506 13.5844C4.86569 13.5563 4.53494 13.4544 4.31444 13.3689C4.02281 13.2556 3.81444 13.1202 3.59569 12.9014C3.37694 12.6827 3.24156 12.4749 3.128 12.1831C3.04244 11.963 2.9405 11.6322 2.91275 11.0229C2.88281 10.364 2.87681 10.1661 2.87681 8.49706C2.87681 6.82806 2.88281 6.63119 2.91275 5.97231C2.94062 5.36294 3.04244 5.03219 3.128 4.81187C3.24131 4.52019 3.37694 4.31188 3.59575 4.09313C3.8145 3.87438 4.02281 3.73894 4.3145 3.62544C4.53481 3.5395 4.86569 3.43794 5.47506 3.40994C6.05162 3.38387 6.27506 3.37606 7.43988 3.37475V3.37631ZM11.3368 4.41406C10.9228 4.41406 10.5868 4.74969 10.5868 5.16381C10.5868 5.57788 10.9228 5.91381 11.3368 5.91381C11.7509 5.91381 12.0868 5.57788 12.0868 5.16381C12.0868 4.74975 11.7509 4.41381 11.3368 4.41381V4.41406ZM8.00056 5.29038C6.22806 5.29038 4.79094 6.7275 4.79094 8.50006C4.79094 10.2726 6.22806 11.7091 8.00056 11.7091C9.77312 11.7091 11.2098 10.2726 11.2098 8.50006C11.2098 6.72756 9.773 5.29038 8.00044 5.29038H8.00056ZM8.00056 6.41669C9.15112 6.41669 10.0839 7.34938 10.0839 8.50006C10.0839 9.65063 9.15112 10.5834 8.00056 10.5834C6.84994 10.5834 5.91725 9.65063 5.91725 8.50006C5.91725 7.34938 6.84994 6.41669 8.00056 6.41669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_372_1075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.25 17.7323) rotate(-90) scale(15.8572 14.7484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_372_1075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.68006 1.65256) rotate(78.681) scale(7.08825 29.218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.78da3b94d4f470ae661108611dc8b5a6.svg";
export { ForwardRef as ReactComponent };